import React from 'react'
import gql from 'graphql-tag'
import ContentBlock from 'components/ContentBlock'
import Button from 'components/Button'
import { useMutation } from 'components/graphql'
import get from 'lodash/get'
const mutation = gql`
	mutation importFruticoProducts{
		cashAssist {
			importFruticoProducts
	  }
	}
`
// bachmann and bachmann test copy
const allowedCompanies = ['b3ea332e-9e38-466e-b127-e12499fe8a1b', '00d8df67-f260-46a6-a8c6-5ff9bf5d590c']

const Frutico = ({ appData }) => {
	const [mutate] = useMutation(mutation)
	const companyId = get(appData, 'authData.attributes.custom:company', '')

	if(!allowedCompanies.includes(companyId)) {
		return null
	}
	return(
		<ContentBlock label='Frutico'>
			<Button text='Import Frutico Artikel' onClick={mutate}/>
		</ContentBlock>
	)
}

export default Frutico
